import { render, staticRenderFns } from "./ReleaseNoteDetail.vue?vue&type=template&id=09d4e264&scoped=true"
import script from "./ReleaseNoteDetail.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d4e264",
  null
  
)

export default component.exports